<template>
  <main id="main">
    <Transition name="fade">
      <Loader v-if="!$page" />
    </Transition>
    <template v-if="$page">
      <HomeHeader :content="$page.header" data-section="header" />
      <SquareCardsSection :content="$page.menus" :id="$t('anchors.menus')" data-section="menus" />
      <template v-if="$page.sections && $page.sections.length">
        <RepeatableSection
          v-for="(section, sectionKey) in $page.sections"
          :content="section"
          :key="sectionKey"
        />
      </template>
      <SwipeCardsSection :content="$page.promotions" id="promotions" data-section="promotions" />
      <TextImageSection :content="$page.corporate" id="corporate" data-section="corporate" />
      <SquareCardsSection
        :content="$page.businesses"
        :id="$t('anchors.businesses')"
        component="BusinessCard"
        data-section="businesses"
      />
      <SmallCTASection
        :content="$page.careers"
        :id="$t('anchors.careers')"
        data-section="careers"
      />
      <RepeatableSection :content="$page.details" />
    </template>
  </main>
</template>

<script>
import HomeHeader from '@/components/sections/HomeHeader.vue'
import RepeatableSection from '@/components/sections/RepeatableSection.vue'
import SmallCTASection from '@/components/sections/SmallCTASection.vue'
import SquareCardsSection from '@/components/sections/SquareCardsSection.vue'
import SwipeCardsSection from '@/components/sections/SwipeCardsSection.vue'
import TextImageSection from '@/components/sections/TextImageSection.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin'

export default {
  name: 'Home',
  mixins: [PageMetaMixin],
  beetPage: 'home',
  components: {
    Loader,
    HomeHeader,
    RepeatableSection,
    SmallCTASection,
    SquareCardsSection,
    SwipeCardsSection,
    TextImageSection,
  },
}
</script>
